import { useEffect } from 'react';
import axios from 'axios';
import i18n from '@/i18n/config';
import { useAuthStore } from '@/stores/authStore';
import { toAuthUser } from '../auth-user.mapper';

/**
 * Attempts to restore the user session on app load using the httpOnly refresh token cookie.
 * Uses a raw axios call (not apiClient) to avoid circular interceptor logic.
 * Sets isLoading to false when done (whether successful or not).
 */
export function useSessionRestore() {
  const { setAuth, setLoading, isLoading } = useAuthStore();

  useEffect(() => {
    const restoreSession = async () => {
      try {
        const response = await axios.post('/api/v1/auth/refresh', null, {
          withCredentials: true,
        });
        const { accessToken, user: rawUser } = response.data?.data ?? {};
        if (accessToken && rawUser) {
          const user = toAuthUser(rawUser);
          setAuth(user, accessToken);
          // Restore user's language preference
          if (user.language) {
            i18n.changeLanguage(user.language);
          }
        }
      } catch {
        // Not authenticated — that's OK, user will see login
      } finally {
        setLoading(false);
      }
    };

    restoreSession();
  }, [setAuth, setLoading]);

  return { isLoading };
}
